import React from 'react';
import { Pagination } from 'react-bootstrap';
import PaginationInfo from './PaginationInfo';

const PaginationComponent = ({ totalCount, currentPage, perPage, handlePageChange }) => {
  const maxPagesToShow = 3;
  const totalPages = Math.ceil(totalCount / perPage);

  if (totalPages <= 0) {
    return null;
  }

  const getPaginationItems = () => {
    const items = [];
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (startPage > 1) {
      items.unshift(
        <React.Fragment key="start-fragment">
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
          {startPage > 2 && <Pagination.Ellipsis />}
        </React.Fragment>
      );
    }

    if (endPage < totalPages) {
      items.push(
        <React.Fragment key="end-fragment">
          {endPage < totalPages - 1 && <Pagination.Ellipsis />}
          <Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </Pagination.Item>
        </React.Fragment>
      );
    }

    return items;
  };

  return (
    <div>
       <PaginationInfo
        currentPage={currentPage} 
        perPage={perPage} 
        totalCount={totalCount}
      />
      <Pagination className="justify-content-center my-3" size="sm">
        <Pagination.Prev
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label="Previous Page"
        />
        {getPaginationItems()}
        <Pagination.Next
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label="Next Page"
        />
      </Pagination>
    </div>
  );
};

export default PaginationComponent;
